import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '@sharedcommon/services/user.service';
import { catchError, map } from 'rxjs/operators';
import { RawMaterialService } from '@sharedrest/data.restservice';

@Injectable()
export class RawMaterialGuard implements CanActivate, CanActivateChild {

  constructor(private readonly userService: UserService, private readonly rawMatService: RawMaterialService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const id = route.params['id'];
    return this.hasRawMaterial(id);
  }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    const id = route.params['id'];
    return this.hasRawMaterial(id);
  }

  hasRawMaterial(id: string) {
    return id ? this.rawMatService.get(this.userService.getEntity(), id)
      .pipe(
        map(() => true),
        catchError(_ => of(false))
      ) : of(false);
  }
}
